import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { PapiDeviation } from '@wix/da-papi-types';
import {
  BreadcrumbsLayout,
  BreadcrumbsSeparator,
  BreadcrumbsItem,
} from '../Breadcrumbs';

export interface Props {
  tiers?: PapiDeviation[];
  tierId?: string;
}

const TierBreadcrumbs: FC<Props> = ({ tiers, tierId }) => {
  const { t } = useTranslation();
  const thisTier = (tiers || []).find(
    tier => `${tier.tier?.tierId}` === tierId
  );
  if (!(tierId && thisTier)) {
    return null;
  }

  return (
    <BreadcrumbsLayout>
      <BreadcrumbsItem
        isRoot
        label={t('studio.header.tabs.published.subtabs.galleries')}
        href={Url.studio({ published: 'galleries' })}
      />
      <BreadcrumbsSeparator />
      <BreadcrumbsItem label={thisTier.title || 'Untitled'} />
    </BreadcrumbsLayout>
  );
};
TierBreadcrumbs.displayName = 'TierBreadcrumbs';

export default TierBreadcrumbs;
